
export const COURSE_INSTANCE_CONSTANTS = {
  START_INSTANCE: 'Start Instance',
  EDIT_INSTANCE: 'Edit Instance',
  INSTANCE_NAME: 'Instance Name (Suffix)',
  INSTANCE_NAME_ERROR_MESSAGE: 'Instance name is required',
  INSTANCE_NAME_HTML_ERROR: 'Instance name cannot contain HTML tags or script tags',
  INSTANCE_NAME_INVALID_CHARACTERS: 'Instance name must start with a letter and can only contain letters, numbers, and underscores',
  INSTANCE_NAME_LENGTH_ERROR: 'Instance name cannot exceed 50 characters',
  INSTANCE_NAME_LENGTH_ERROR_CREATE: 'Instance name cannot exceed 30 characters',
  INSTANCE_NAME_LENGTH_ERROR_EDIT: 'Instance name cannot exceed 64 characters',
  INSTANCE_DESCRIPTION: 'Description',
  DESCRIPTION_INFO: 'Max of 250 Characters',
  INSTANCE_DESCRIPTION_ERROR_MESSAGE: 'Description is required',
  DESCRIPTION_SIZE_INFO: 'Description cannot exceed 250 characters',
  DESCRIPTION_HTML_ERROR: 'Description cannot contain HTML tags or script tags',
  DESCRIPTION_INVALID_CHARACTERS: 'Description can only contain letters, numbers, spaces, hyphens, dots, commas, and underscores',
  BATCH_SIZE: 'Batch Size',
  BATCH_SIZE_ERROR_MESSAGE: 'Batch size is required',
  BATCH_SIZE_INFO: 'Batch size must contain numeric values only',
  BATCH_SIZE_REGEX: '^[0-9]+$',
  BATCH_SIZE_MIN: 'Batch size must be greater than 0',
  BATCH_SIZE_MAX: 'Batch size must not exceed 20',
  START_DATE: 'Start Date',
  START_DATE_ERROR_MESSAGE: 'Start date is required',
  START_DATE_MAX_ERROR: 'Start date cannot be more than 1 year from current date',
  EXPIRY_DATE: 'Expiry Date',
  EXPIRY_DATE_ERROR_MESSAGE: 'Expiry date is required',
  EXPIRY_DATE_INFO: 'Back dates are not allowed',
  EXPIRY_DATE_BEFORE_ORIGINAL: 'Expiry date cannot be before the original course expiry date',
  EXPIRY_DATE_VALIDATION: "Expiry date cannot be more than 90 days from the original course expiry date.",
  COURSE_CONFIGURATION: 'Course Configuration',
  COURSE_NAME: 'Course Name',
  COURSE_NAME_INFO: 'Only one template can be selected',
  COURSE_NAME_ERROR_MESSAGE: 'Course name is required',
  COURSE_TYPE: 'Course Type',
  COURSE_TYPE_ERROR_MESSAGE: 'Course type is required',
  EMAIL_STATUS: 'Email Status',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  NEXT: 'Next',
  PREVIOUS_STEP: 'Previous Step',
  GENERAL_DETAILS: 'General Details',
  EMAIL_REGEX: /^[a-zA-Z0-9][a-zA-Z0-9._-]*@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/,
  INVITE_STUDENT: 'Invite Student',
  ADD: 'Add',
  ASSIGN_INSTRUCTOR: 'Assign Instructor',
  ASSIGN_INSTRUCTOR_MAX: 'Comma-separated emails, max',
  ENTER_EMAIL: 'Please enter an email address',
  INVALID_EMAIL: 'Invalid email format',
  EMAIL_CHARACTER_LIMIT: 'Email address cannot exceed 50 characters',
  DUPLICATE_EMAIL_FOUND: 'Duplicate email(s) found and ignored',
  MAXIMUM_EMAIL_SIZE: 'Maximum 4 instructors allowed',
  INSTRUCTOR_REQUIRED: "At least one instructor is required",
  STUDENT_INSTRUCTOR_EMAIL_SAME: 'Student and instructor emails cannot be the same',
  PARTICIPANTS_DETAILS: 'Participants Details',
  NO_DATA_FOUND : "No data found",
  BACK_TO_LIBRARY_MANAGEMENT: "Back to Library Management",
  CANCEL_COURSE_INSTANCE_CREATION: {
    TITLE: "Cancel Course Instance Creation",
    MESSAGE: "All unsaved changes will be lost. Do you want to continue ?",
    BUTTONS: {
      NO: "NO",
      YES: "YES"
    }
  },
  CANCEL_COURSE_INSTANCE_UPDATION: {
    TITLE: "Cancel Course Instance Updation",
    MESSAGE: "All unsaved changes will be lost. Do you want to continue ?",
    BUTTONS: {
      NO: "NO",
      YES: "YES"
    }
  },
  SUCCESS_TOAST: {
    SUCCESS: 'Success',
    CONTENT: "has been successfully deployed."
  },
  ERROR_TOAST: {
    ERROR: 'Failed to create course instance',
    CONTENT: "Something went wrong while deploying the course instance."
  },
  UPDATE_COURSE_INSTANCE: {
    SUCCESS_TOAST: {
      SUCCESS: 'Success',
      CONTENT: "has been successfully updated."
    },
    ERROR_TOAST: {
      ERROR: 'Failed to update course instance',
      CONTENT: "Something went wrong while updating the course instance."
    }
  },
  COURSE_DURATION: {
    LABEL: "Course Duration (Days)",
    PLACEHOLDER: "Duration",
    ERRORS: {
      REQUIRED: "Course duration is required",
      NUMERIC: "Course duration must be a whole number",
      MIN: "Course duration must be at least 1 day",
      MAX: "Course duration cannot exceed 30 days",
      NUMERICAL: "Only numerical numbers allowed"
    }
  },
  CANCEL_WITHOUT_SAVING_TOAST: {
    UPDATION_CANCELLED: 'Course instance updation Cancelled',
    CREATION_CANCELLED: 'Course instance creation Cancelled',
    NO_DATA_SAVED: 'No data saved'
  }
}